import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const TemplateChangeDecisionDialog = ({
  open,
  decision = null,
  onCancel,
  onDecision,
  t,
}) => (
  <Dialog open={Boolean(open)} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>
      {t('template.change_decision_title', 'This project is linked to a template')}
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {t(
          'template.change_decision_message',
          `You changed ${decision?.changeLabel || 'this item'}. Choose whether to keep the change only in this project or propagate it to all linked projects.`
        )}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {decision?.templateTitle || t('dashboard.template_fallback', 'Template')}
        {decision?.templateId ? ` (#${decision.templateId})` : ''}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel}>
        {t('common.cancel', 'Cancel')}
      </Button>
      <Button variant="outlined" color="warning" onClick={() => onDecision?.('detach')}>
        {t('template.detach_project', 'Disconnect Project')}
      </Button>
      <Button variant="contained" onClick={() => onDecision?.('propagate')}>
        {t('template.update_template', 'Update Template')}
      </Button>
    </DialogActions>
  </Dialog>
);

export default TemplateChangeDecisionDialog;
